<div class="row justify-content-center allergy-card">
    <!-- <div class="col-6 col-sm-5 col-md-3" *ngIf="pastHHX.length == 0">
        <div class="bg-info h-100 card mb-3 p-3 text-center text-white" (click)="modalPastHospHX()">
            <span class="icon mb-3">
                <img height="25" src="../../../assets/images/Icons/plus.svg">
            </span>
            <h6 class="font-weight-normal mb-0">Add Past Hospitalization History</h6>
        </div>
    </div> -->
    <div class="col-6 col-sm-5 col-md-3" *ngIf="pastHHX.length == 0">
        <div class="bg-info card h-100 mb-3 p-3 text-center text-white" (click)="modalPastHospHX()">
            <span class="bg-white icon mb-3">
                <img height="23" src="../../../assets/images/Icons/plus.svg">
            </span>
            <h6 class="font-weight-normal mb-0">{{'post_hospitalization.add_past_hospitalization_history'|translate}}</h6>
        </div>
    </div>
    <div class="col-6 col-sm-5 col-md-3" *ngIf="pastHHX.length == 0">
        <div class="card mb-3 h-100 p-3 text-center text-info" (click)="setNoKnownPastHospHX()">
            <span class="icon mb-3">
                <img height="23" src="../../../assets/images/Icons/cross.svg">
            </span>
            <h6 class="font-weight-normal mb-0">{{'post_hospitalization.no_known_past_hospitalization_history'|translate}}</h6>
        </div>
    </div>

    <!--<div class="col-12" *ngIf="pastHHX.length > 0">
      <button class="btn btn-primary btncare" style="float: right;" type="button" (click)="modalPastHospHX()">
        {{'button.add_PH'|translate}}
      </button>
    </div>-->

</div>
<!-- <div class="col-12 mt-3" *ngIf="pastHHX.length >0">
        <table *ngFor="let pastHosp of pastHHX" class="table table-bordered">
            <tr [ngStyle]="{'display' : intakeFieldsSetting.isPastHospitalizationDate ? '' : 'none'}">
                <td width="150">Date</td>
                <td>{{pastHosp.hosP_DATE == 'null' || pastHosp.hosP_DATE == '' ? 'N/A' : pastHosp.hosP_DATE}}</td>
            </tr>
            <tr [ngStyle]="{'display' : intakeFieldsSetting.isPastHospitalizationDuration ? '' : 'none'}">
                <td width="150">Duration</td>
                <td>{{pastHosp.duration || 'N/A'}}</td>
            </tr>
            <tr>
                <td width="150">Reason</td>
                <td>{{pastHosp.reason || 'N/A'}}</td>
            </tr>
            <tr>
                <td width="150">Action</td>
                <td>
                    <div class="ctabtns">
                        <a (click)="editPastHosp(pastHosp)" data-toggle="modal"
                        class="mr-3"><i title="Edit" class="fas fa-edit text-dark"></i></a>
                        <a (click)="deletePastHospitalization(pastHosp)"><i title="Delete" class="far fa-trash-alt text-danger"></i></a>
                    </div>
                </td>
            </tr>
        </table>
    </div>
    <div *ngIf="pastHHX.length == 0" class="col-12 mt-4">
        <div class="card border">
            <div class="card-body text-center">
                <p>No Post-hospitalization history.</p>
            </div>
        </div>
    </div> -->
<ng-container *ngIf="pastHHX.length >0 else notFoundPA">
    <div  class="container flex-grow-1 overflow-auto">
        <div class="specialist-list ">
          <div class="form-row">
            <div class="col-12 mb-4 mt-2" *ngIf="pastHHX.length > 0">
              <button class="btn btn-primary btncare" style="float: right;" type="button" (click)="modalPastHospHX()">
                {{'button.add_PH'|translate}}
              </button>
            </div>
            <div class="col-lg-6" *ngFor="let pastHosp of pastHHX">
              <div class="card  mb-4 pb-3">
                <div class="card-body p-0">
                  <!--<div class="d-flex flex-sm-row justify-content-between mb-2 position-absolute mr-1r">
                    <div class="ctabtns d-flex">
                    
                      <a href="javascript:void(0)" (click)="deletePastHospitalization(pastHosp)" class="text-dark">
                        {{'link.delete'|translate}}
                      </a>
                    </div>
                  </div>-->
                  <div class="align-items-center d-flex justify-content-between mb-3">
                      <span> </span>

                    <div class="ctabtns">
 
                      <a href="javascript:void(0)" (click)="deletePastHospitalization(pastHosp)" class="text-dark">
                        {{'link.delete'|translate}}
                      </a>
                    </div>
                  </div>

                  <div class="mb-2 mw-action"
                       [ngStyle]="{'display' : intakeFieldsSetting.isPastHospitalizationDate ? '' : 'none'}">
                    <span>{{'post_hospitalization.date'|translate}}: </span>
                    <span *ngIf="pastHosp.hosP_DATE != '' && pastHosp.hosP_DATE != 'null'" class="text-muted font-weight-bold mr-1">{{pastHosp.hosP_DATE | date:'MM/dd/yyyy' }}</span>
                    <span *ngIf="pastHosp.hosP_DATE == '' || pastHosp.hosP_DATE == 'null'" class="text-muted font-weight-bold mr-1"></span>
                  </div>
                  <div class="mb-2"
                       [ngStyle]="{'display' : intakeFieldsSetting.isPastHospitalizationDuration ? '' : 'none'}">
                    <span>{{'post_hospitalization.duration_label'|translate}}: </span>
                    <span class="text-muted font-weight-bold mr-1">{{(pastHosp.duration | titlecase) || 'N/A'}}</span>
                  </div>
                  <div>
                    <span>{{'post_hospitalization.reason'|translate}}: </span>
                    <span class="text-muted font-weight-bold mr-1">{{(pastHosp.reason  | titlecase)|| 'N/A'}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</ng-container>
<ng-template #notFoundPA>

    <div class="col-12 mt-4 text-center px-0">
      <p class="mb-0 text-danger">{{'post_hospitalization.no_post_hospitalization_history'|translate}}</p>
    </div>
</ng-template>

<!-- delete  -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="delPastHosp">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body p-4 text-center">
                <h5 class="font-weight-bolder mb-3 text-danger"><strong>
  {{'post_hospitalization.are_you_sure_you_want_to_delete_hospitalization_history'|translate}}
</strong></h5>
                <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                        id="closeDeleteAllergyModel">
                  {{'button.cancel'|translate}}
                </button>
                <button type="button" id="closeDeleteFamilyHistory" (click)="DeleteSurgicalHX()"
                        class="btn btn-primary rbtn">
                  {{'button.delete'|translate}}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- New past surgical history Modal -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="newPastHosp">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{'post_hospitalization.add_past_hospitalization_history'|translate}}</h5>
                <button type="button" class="close" data-dismiss="modal" (click)="reset()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-md-12"
                     [ngStyle]="{'display' : intakeFieldsSetting.isPastHospitalizationDate ? '' : 'none'}">
                  <!--<div class="form-group form-floating">
      <input name="date" class="form-control add-on" (change)="onChangeDate($event)" max="{{curDate | date:'yyyy-MM-dd'}}"
             (focusout)="focusOutFunction($event, 0)" min="{{'1970-01-01' | date:'yyyy-MM-dd'}}"
             tabindex="17" type="date" [(ngModel)]="savepastHHX.hospDate">
      <label>Hospitalization Date</label>
      <p *ngIf="isDateError" class="err">Selected date should be prior to current date.</p>
    </div>-->
                  <div class="form-group border-bottom">
                    <label class="form-label fw-bold">{{'post_hospitalization.hospitalization_date_label'|translate}}</label>
                    <input name="date" class="form-control add-on border-0" (change)="onChangeDate($event)" max="{{curDate | date:'yyyy-MM-dd'}}"
                           (focusout)="focusOutFunction($event, 0)" min="{{'1901-01-01' | date:'yyyy-MM-dd'}}"
                           tabindex="17" type="date" [(ngModel)]="savepastHHX.hospDate">
                  </div>
                  <p *ngIf="isDateError" class="err">{{'post_hospitalization.selected_date_should_be_prior_to_current_date'|translate}}</p>
                </div>
                <div class="col-md-12"
                     [ngStyle]="{'display' : intakeFieldsSetting.isPastHospitalizationDuration ? '' : 'none'}">
                  <div class="form-group border-bottom">
                    <label class="form-label fw-bold">{{'post_hospitalization.duration_label'|translate}}</label>
                    <input name="duration" [(ngModel)]="savepastHHX.duration" class="form-control border-0"
                           placeholder="{{'post_hospitalization.duration_placeholder'|translate}}" type="text" id="phd">

                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <div class="mb-2 border-bottom fw-bold">
                      <label class="form-label fw-bold">{{'post_hospitalization.hospitalization_reason_label'|translate}}<span class="text-danger">*</span></label>
                      <textarea name="comment" [(ngModel)]="savepastHHX.reason" type="text" rows="1"
                                placeholder="{{'post_hospitalization.hospitalization_reason_here_placeholder'|translate}}" class="form-control border-0"
                                (input)="inputreasonName($event,'add')" id="phr"></textarea>
                    </div>
                    <div class="mb-2">
                      <span *ngIf="isAddReasonNull" class="err">
                        {{'post_hospitalization.please_enter_reason'|translate}}
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary" (click)="reset()" data-dismiss="modal">{{'button.close'|translate}}</button>
              <button type="button" type="button" (click)="savePastHospHX()" class="btn btn-primary ">{{'button.save'|translate}}</button>
            </div>
        </div>
    </div>
</div>

<!-- edit past surgical history Modal -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="editPastHosp">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{'post_hospitalization.update_past_hospitalization_history'|translate}}</h5>
                <button type="button" class="close" data-dismiss="modal" (click)="reset()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-row">
                  <div class="col-md-12"
                       [ngStyle]="{'display' : intakeFieldsSetting.isPastHospitalizationDate ? '' : 'none'}">
                    
                    <div class="form-group form-floating">
                      <input class="form-control add-on" (change)="onChangeDate($event)" tabindex="17" type="date"
                             (focusout)="focusOutFunction($event, 1)" min="{{'1901-01-01' | date:'yyyy-MM-dd'}}"
                             max="{{curDate | date:'yyyy-MM-dd'}}" [(ngModel)]="updatePastHosp.hosP_DATE">
                      <label>{{'post_hospitalization.hospitalization_date_label'|translate}}</label>
                      <p *ngIf="isDateError" class="err">{{'post_hospitalization.selected_date_should_be_prior_to_current_date'|translate}}</p>
                    </div>
                  </div>
                    <div class="col-md-12"
                        [ngStyle]="{'display' : intakeFieldsSetting.isPastHospitalizationDuration ? '' : 'none'}">
                        <div class="form-group form-floating">
                            <input type="text" class="form-control" placeholder="{{'post_hospitalization.duration'|translate}}"
                                [(ngModel)]="updatePastHosp.duration">
                            <label>{{'post_hospitalization.duration'|translate}}</label>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group form-floating">
                            <textarea type="text" [(ngModel)]="updatePastHosp.reason" rows="3"
                                placeholder="{{'post_hospitalization.hospitalization_reason_here_placeholder'|translate}}" class="form-control"
                                (input)="inputreasonName($event,'update')"></textarea>
                            <label>{{'post_hospitalization.hospitalization_reason_label'|translate}}<span class="text-danger">*</span></label>
                            <p *ngIf="isUpdateReasonNull" class="err">{{'post_hospitalization.please_enter_reason'|translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary" (click)="reset()" data-dismiss="modal">{{'button.close'|translate}}</button>
              <button type="button" type="button" (click)="updatePastHospHX()"
                      class="btn btn-primary ">
                {{'button.update'|translate}}
              </button>
            </div>
        </div>
    </div>
</div>
